import React, { useContext } from 'react'

import { StockReportsClient } from './stock-reports.app.client'

const StockopediaClientContext = React.createContext<StockReportsClient>(
  {} as any,
)

interface Props {
  client: StockReportsClient
}

export const ApiClientProvider: React.FC<Props> = ({ client, children }) => {
  return (
    <StockopediaClientContext.Provider value={client}>
      {children}
    </StockopediaClientContext.Provider>
  )
}

export const useApiClient = () => useContext(StockopediaClientContext)
